import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-cookies-modal',
  templateUrl: './cookies-modal.component.html',
  styleUrls: ['./cookies-modal.component.scss'],

})
export class CookiesModalComponent {
  @Input() visible: boolean = false;
  @Input() cookiesContent: any;
  @Input() title: string = ''
  @Output() closeModal = new EventEmitter<void>();
 

  onHide(): void {
    this.closeModal.emit();
  }
}